import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import bizBenefitMethod from "@/business/businessTools/bizBenefitMethod";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";

var backfillHistoryData = function backfillHistoryData(_this) {
  var productInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (!_.isEmpty(productInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], productInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], productInfo);
  }
  if (_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_CODE.DEFAULT_VALUE == "0") {
    _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_CODE.isCheckCheckbox = true;
    _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_DATE.FIELD_REQUIRED = "0";
  } else {
    _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_CODE.isCheckCheckbox = false;
    _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_DATE.FIELD_REQUIRED = "1";
  }
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  fields.PRO_BAK_CODE.IS_SHOW_CHECKBOX = true;
  fields.PRO_CLS.FIELD_DICT_NAME = _.filter(fields.PRO_CLS.FIELD_DICT_NAME, function (item) {
    return !["02", "02a", "02b", "02", "02c", "02d", "02e", "02f", "03", "03a", "04", "05", "05a", "05b", "05c", "99d", "99e", "99f", "99g", "99h", "99i"].includes(item.DICT_ITEM);
  });
  fields.STRUCT_PRO_FLAG.FIELD_TYPE = "radio";
  fields.PRO_SIZE.unitText = "万元";

  _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_DATE.isLongItem = false;

  fields.PRO_SIZE.VALID_TYPE = "number[10,4]";
  fields.PRO_BAK_REMARK.VALID_TYPE = "length[0,64]";
  fields.PRO_BAK_CODE.VALID_TYPE = "length[0,48]";
  fields.PRO_BAK_DATE.VALID_TYPE = "begin";
  fields.INVEST_RANAGE.isLongItem = true;
  _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.INVEST_RANAGE.isLongItem = true;
};

var update = function update(_this) {
  var module = _this.groupDatas[GROUP_ID][MODULE_ID][0];
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

  var _loop = function _loop(key) {
    var funcArr = _.get(fields[key], "FIELD_FUNCTION", "").split("|");
    _.each(funcArr || [], function (func) {
      NODE[func] && NODE[func](_this, fields[key], fields, module);
    });
  };

  for (var key in fields) {
    _loop(key);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {
    initFieldConfig(_this);
    _this.oppBusiData.singleREG = ["01", "03", "03a", "06", "07", "08", "08a", "12", "12a", "15", "16", "21", "23", "23a", "23b", "23c", "23d", "23e", "23f"];
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
    _this.oppBusiData.isShowBeneficiaryTypeAlert = _.get(_this, "historyData.DETAIL_DATA.isShowBeneficiaryTypeAlert") || "0";
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var fields, productInfo, productSourceInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fields = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2]);
              productInfo = {
                PRO_NAME: fields.PRO_NAME,
                PRO_SNAME: fields.PRO_SNAME,
                PRO_CLS: fields.PRO_CLS,
                PRO_CREAT_DATE: fields.PRO_CREAT_DATE,
                PRO_EXP_DATE: fields.PRO_EXP_DATE,
                PRO_SIZE: fields.PRO_SIZE,
                PRO_VAL: fields.PRO_VAL,
                PRO_VAL_DATE: fields.PRO_VAL_DATE,
                PRO_BAK_ORG: fields.PRO_BAK_ORG,
                PRO_BAK_REMARK: fields.PRO_BAK_REMARK,
                PRO_BAK_CODE: fields.PRO_BAK_CODE,
                PRO_BAK_DATE: fields.PRO_BAK_DATE,
                PRO_OPEN_DATE: fields.PRO_OPEN_DATE,
                PRO_CON_SNO: "",
                SMFUND_TYPE: fields.SMFUND_TYPE,
                SMFUND_REMARK: fields.SMFUND_REMARK,
                SMFUND_MANAGER_TYPE: fields.SMFUND_MANAGER_TYPE,
                SMFUND_MANAGER_REMARK: fields.SMFUND_MANAGER_REMARK,
                STRUCT_PRO_FLAG: fields.STRUCT_PRO_FLAG,
                INIT_LEVERAGE: fields.INIT_LEVERAGE,
                INVEST_RANAGE: fields.INVEST_RANAGE
              };
              productSourceInfo = {};

              _.each(productInfo, function (value, key) {
                productInfo[key + "_DATA_SOURCE"] = fields[key + "_DATA_SOURCE"];
              });
              _Object$assign(productInfo, productSourceInfo);

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], productInfo);

              _.set(params, SAVE_PATH, _Object$assign({}, _.get(params, SAVE_PATH, {}), productInfo));
              params.DETAIL_DATA.isShowBeneficiaryTypeAlert = _this.oppBusiData.isShowBeneficiaryTypeAlert;

              _this.removeFlowTip("confirmProcls");

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),
  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {
    if (_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_CODE.isCheckCheckbox) {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_CODE.DEFAULT_VALUE = "0";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_CODE.FIELD_REQUIRED = "0";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_CODE.FIELD_CONTROL = "2";
    } else {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_CODE.FIELD_REQUIRED = "1";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.PRO_BAK_CODE.FIELD_CONTROL = "0";
    }
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  preValidate: function preValidate(_this) {
    _this.removeFlowTip("confirmProcls");
  },
  "CHECK_PRO_CLS": function CHECK_PRO_CLS(_this, field, fieldData) {
    _this.removeFlowTip("confirmProcls");

    if (["08", "08a"].includes(field.DEFAULT_VALUE)) {
      fieldData.SMFUND_TYPE.FIELD_CONTROL = "0";
      fieldData.SMFUND_MANAGER_TYPE.FIELD_CONTROL = "0";
    } else if (["99c", "99b"].includes(field.DEFAULT_VALUE)) {
      _this.pushFlowTip({
        title: "请确认该客户是否开在普通柜台。",
        key: "confirmProcls",
        type: "warning"
      });
    } else {
      fieldData.SMFUND_TYPE.FIELD_CONTROL = "1";
      fieldData.SMFUND_MANAGER_TYPE.FIELD_CONTROL = "1";

      fieldData.SMFUND_REMARK.DEFAULT_VALUE = "";
      fieldData.SMFUND_MANAGER_REMARK.DEFAULT_VALUE = "";

      fieldData.SMFUND_TYPE.DEFAULT_VALUE = "";
      fieldData.SMFUND_MANAGER_TYPE.DEFAULT_VALUE = "";
    }
    if (_this.$store.state.canCleanData) {
      var flag = false;
      var resetBeneficiaryType = function resetBeneficiaryType(module) {
        module = _.get(_this, module);
        _.find(module, function (mdd) {
          if (mdd.FIELDS && mdd.FIELDS.BENEFICIARY_TYPE && mdd.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE !== "") {
            mdd.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE = "";
            flag = true;
            return true;
          }
          return false;
        });
      };
      _.each(bizBenefitMethod.BENEFICIARY_ALL_ARR, resetBeneficiaryType);
      if (flag) {
        _this.oppBusiData.isShowBeneficiaryTypeAlert = "1";
        bizBenefitMethod.changeProCls(_this, field.DEFAULT_VALUE, true);
      }
    }

    fieldData.SMFUND_REMARK.FIELD_CONTROL = "1";

    fieldData.SMFUND_MANAGER_REMARK.FIELD_CONTROL = "1";

    fieldData.SMFUND_REMARK.DEFAULT_VALUE = "";

    fieldData.SMFUND_MANAGER_REMARK.DEFAULT_VALUE = "";

    fieldData.SMFUND_TYPE.DEFAULT_VALUE = "";

    fieldData.SMFUND_MANAGER_TYPE.DEFAULT_VALUE = "";

    if (["03", "08", "12", "16", "23", "23a", "23b", "23c", "23d", "23e", "23f"].includes(field.DEFAULT_VALUE)) {
      _this.groupDatas.OTHER_INFO_PAGE.PRO_ORD_INFO[0].MODULE_CONTROL = "1";
    } else {
      _this.groupDatas.OTHER_INFO_PAGE.PRO_ORD_INFO[0].MODULE_CONTROL = "0";
    }
  },
  "CHECK_PRO_BAK_CODE": function CHECK_PRO_BAK_CODE(_this, field, fieldData) {},
  CHECK_PRO_BAK_CODE__CLICK: function CHECK_PRO_BAK_CODE__CLICK(_this, field, fieldData) {
    if (field.isCheckCheckbox) {
      field.DEFAULT_VALUE = "0";
      field.FIELD_REQUIRED = "0";
      field.FIELD_CONTROL = "2";
      fieldData.PRO_BAK_DATE.FIELD_REQUIRED = "0";
    } else {
      field.DEFAULT_VALUE = "";
      field.FIELD_REQUIRED = "1";
      field.FIELD_CONTROL = "0";
      fieldData.PRO_BAK_DATE.FIELD_REQUIRED = "1";
    }
  },
  "CHECK_PRO_BAK_ORG": function CHECK_PRO_BAK_ORG(_this, field, fieldData) {
    if (!field.DEFAULT_VALUE) {
      fieldData.PRO_BAK_REMARK.FIELD_CONTROL = "1";
      fieldData.PRO_BAK_REMARK.FIELD_REQUIRED = "0";
      return;
    }
    if (field.DEFAULT_VALUE === "9") {
      fieldData.PRO_BAK_REMARK.FIELD_CONTROL = "0";
      fieldData.PRO_BAK_REMARK.FIELD_REQUIRED = "1";
      fieldData.PRO_BAK_REMARK.VALID_TYPE = "length[0,64]";
    } else {
      fieldData.PRO_BAK_REMARK.FIELD_CONTROL = "1";
      fieldData.PRO_BAK_REMARK.FIELD_REQUIRED = "0";
      fieldData.PRO_BAK_REMARK.VALID_TYPE = "";
    }
  },
  "CHECK_SMFUND_TYPE": function CHECK_SMFUND_TYPE(_this, field, fieldData) {
    if (field.DEFAULT_VALUE) {
      if (field.DEFAULT_VALUE == "3") {
        fieldData.SMFUND_REMARK.FIELD_CONTROL = "0";
        fieldData.SMFUND_REMARK.VALID_TYPE = "length[0,64]";
        fieldData.SMFUND_REMARK.FIELD_REQUIRED = "1";
      } else {
        fieldData.SMFUND_REMARK.FIELD_CONTROL = "1";
      }
    }
  },
  "CHECK_SMFUND_MANAGER_TYPE": function CHECK_SMFUND_MANAGER_TYPE(_this, field, fieldData) {
    if (field.DEFAULT_VALUE) {
      if (field.DEFAULT_VALUE == "2") {
        fieldData.SMFUND_MANAGER_REMARK.FIELD_CONTROL = "0";
        fieldData.SMFUND_MANAGER_REMARK.VALID_TYPE = "length[0,64]";
        fieldData.SMFUND_MANAGER_REMARK.FIELD_REQUIRED = "1";
      } else {
        fieldData.SMFUND_MANAGER_REMARK.FIELD_CONTROL = "1";
      }
    }
  },
  "CHECK_STRUCT_PRO_FLAG": function CHECK_STRUCT_PRO_FLAG(_this, field, fieldData) {
    if (field.DEFAULT_VALUE) {
      if (field.DEFAULT_VALUE == "1") {
        fieldData.INIT_LEVERAGE.FIELD_CONTROL = "0";
        fieldData.INIT_LEVERAGE.VALID_TYPE = "length[0,64]";
      } else {
        fieldData.INIT_LEVERAGE.FIELD_CONTROL = "1";
        fieldData.INIT_LEVERAGE.DEFAULT_VALUE = "";
      }
    }
  },
  update: update
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS421/bizPro/bizProBaseInfo.js
// module id = 210
// module chunks = 2